import { useEffect } from 'react';
import { useStores } from '../components/store';
import { throttle } from 'lodash';
import moment from 'moment';

export const useUserActivityTimer = () => {

    const LAST_ACCESS_KEY = 'lastAccessTime';

    const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minutes

    const { userStore } = useStores();

    const updateLastAccess = () => {
        localStorage.setItem(LAST_ACCESS_KEY, moment().toLocaleString());
    };

    const isUserInactive = () => {
        const lastAccessString = localStorage.getItem(LAST_ACCESS_KEY);
        if (lastAccessString &&
            moment(lastAccessString).isBefore(moment().subtract(INACTIVITY_TIMEOUT, 'ms'))) {
                void userStore.logout();
        }
    };

    useEffect(() => {
        if (userStore.isAuthenticated) {
            const updateLastAccessThrottle = throttle(updateLastAccess, 5000);
            window.addEventListener('mousemove', updateLastAccessThrottle);

            updateLastAccess();
            const inactivityInterval = setInterval(isUserInactive, 10000);

            return () => {
                window.removeEventListener('mousemove', updateLastAccessThrottle);
                updateLastAccessThrottle.cancel();
                clearInterval(inactivityInterval);
            };
        }
    }, [userStore.isAuthenticated]);
};